import PaymentService from "../service/paymentService";

export const userDetail = (data) => {
    return {
        type: 'ADD_USER_INFO',
        payload: data
    }
}

export const leadDetail = (data) => {
    return {
        type: 'ADD_LEAD_INFO',
        payload: data
    }
}

export const detailPage = (data) => {
    return {
        type: 'DETAIL_PAGE',
        payload: data
    }
}

export const updateActivePage = (data) => {
    return {
        type: 'UPDATE_ACTIVE_PAGE',
        payload: data
    }
}


export const updateLead = (lead_id,lead_source) => {
    return (dispatch) => {
        PaymentService.getLeadDetails({ lead_id: lead_id,lead_source:lead_source })
            .then((response) => {
                if (response.status === 200 && response.data.status === 200) {
                    let leadDetails = response.data.data || {};
                    dispatch({ type: 'UPDATE_LEAD_INFO', payload: leadDetails })
                    dispatch({ type: 'UPDATE_ACTIVE_PAGE', payload: leadDetails.details.active_tab })
                }
            })
            .catch(() => {
                 
            })
    }
}

export const notificationUpdate = (user_id) => {
    return (dispatch) => {
        // PaymentService.getNotificationList({ user_id: user_id })
        //     .then((response) => {
        //         if (response.status === 200 && response.data.status === 200) {
        //             let { items, totalReadable ,loginStatus} = response.data.data;
        //             let messageList = (items.length > 0) ? items : []
        //             dispatch({ type: 'UPDATE_NOTIFICATION', payload: messageList });
        //             dispatch({ type: 'UPDATE_UNSEEN_NOTIFICATION', payload: totalReadable });
        //             dispatch({ type: 'USER_LOGIN_STATUS', payload: loginStatus });
        //         }
        //     })
        //     .catch(() => {
                 
        //     })
    }
}

export const setPaymentFilters = (data, activeTab = '') => {
    return {
        type: 'SET_PAYMENT_FILTER',
        payload: data,
        activeTab: activeTab
    }
}

export const getReports = (postData) => {
    return async () => {
    try {
        const {
            status,
            data
        } = await PaymentService.getReport(postData);

        if (status === 200) {
            return {
                status: true,
                response: data.message,
                data:data
            };
        } else
            return {
                status: false,
                response: data.message,
            };
    } catch (err) {
        return {
            status: false,
            response: err,
        };
    }
};
}

export const getReportsNew = (postData, endPoint) => {
    return async () => {
    try {
        const {
            status,
            data
        } = await PaymentService.getReportNew(postData, endPoint);

        if (status === 200) {
            return {
                status: true,
                response: data.message,
                data:data
            };
        } else
            return {
                status: false,
                response: data.message,
            };
    } catch (err) {
        return {
            status: false,
            response: err,
        };
    }
};
}

export const updateCurrency = (data) => {
    return {
        type: 'UPDATE_CURRENCY_CONVERSION',
        payload: data
    }
}

export const logout = (data) => {
    return {
        type: 'LOGOUT',
        payload: data
    }
}

export const updateCheckBox = (data) => {
    return {
        type: 'UPDATE_RADIO_CHECK',
        payload: data
    }
}

export const setFrontendConfig = (data) => {
    return {
        type: 'SET_FRONTEND_CONFIG',
        payload: data
    }
}


